module.exports = __webpack_public_path__ + "img/div6-3s.b18cdd4b.jpg";